import { useQuery } from '@tanstack/react-query';
import { useUserStore } from '@/store/userStore';
import { getPopularClasses } from '@/services/edgeFunctionWrappers/dashboardStatsWrapper';
import { format, subDays } from 'date-fns';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Trophy, Medal, Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';

const MEDAL_COLORS = [
  'text-yellow-500',
  'text-gray-400',
  'text-amber-700',
];

export function TopCoursesWidget() {
  const { gymId } = useUserStore();
  
  const { data, isLoading } = useQuery({
    queryKey: ['top-courses', gymId],
    queryFn: () => getPopularClasses(
      gymId!,
      format(subDays(new Date(), 30), 'yyyy-MM-dd'),
      format(new Date(), 'yyyy-MM-dd')
    ),
    enabled: !!gymId,
    staleTime: 10 * 60 * 1000, // 10 minutes
  });

  if (isLoading) {
    return (
      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-sm font-medium flex items-center gap-2">
            <Trophy className="h-4 w-4 text-primary" />
            Top 3 cours
          </CardTitle>
        </CardHeader>
        <CardContent className="flex items-center justify-center h-24">
          <Loader2 className="h-5 w-5 animate-spin text-muted-foreground" />
        </CardContent>
      </Card>
    );
  }

  const topCourses = data?.slice(0, 3) || [];

  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-sm font-medium flex items-center gap-2">
          <Trophy className="h-4 w-4 text-primary" />
          Top 3 cours (30 jours)
        </CardTitle>
      </CardHeader>
      <CardContent className="pt-0">
        {topCourses.length === 0 ? (
          <p className="text-sm text-muted-foreground text-center py-4">
            Aucune donnée disponible
          </p>
        ) : (
          <ul className="space-y-2">
            {topCourses.map((course, index) => (
              <li 
                key={course.class_name} 
                className="flex items-center justify-between py-1.5 border-b last:border-0"
              >
                <div className="flex items-center gap-2">
                  <Medal className={cn("h-4 w-4", MEDAL_COLORS[index])} />
                  <span className="text-sm font-medium">{course.class_name}</span>
                </div>
                <span className="text-xs text-muted-foreground">
                  {course.booking_count} réservations
                </span>
              </li>
            ))}
          </ul>
        )}
      </CardContent>
    </Card>
  );
}
